const styles = {
  paper: {
    borderRadius: 3,
    maxWidth: 1120,
  },
  title: {
    px: 4,
    pt: 4,
    pb: 2,
  },
  content: {
    px: 4,
    py: 2,
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  itemHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    bgcolor: 'secondary.main',
    p: 2,
    pl: 4,
  },
  itemTitle: {
    fontSize: 24,
    fontWeight: 700,
  },
  deleteButton: {
    fontSize: 22,
    fontWeight: 600,
    textTransform: 'none',
  },

  addButton: {
    fontSize: 24,
    fontWeight: 600,
    textTransform: 'none',
  },
  actions: {
    px: 4,
    pb: 4,
    pt: 2,
  },
  actionButton: {
    minWidth: 140,
  },
};

export default styles;
